import React from 'react'
import SarasTrans from '../../../library/notifications/SarasTrans';

//starting with capital letter will ensure this is treated as a component
const InvRouteItemH = ({col}) => {

    return (
        <div className="uiSearchRouteItemList">
            <span className="sSeqNo uiCenter"><SarasTrans value="Seq No" /></span>
            <span className="sTktNo uiCenter"><SarasTrans value="Tkt No" /></span>
            <span className="sItemCode uiCenter"><SarasTrans value="PNR" /></span>
            <span className="sItemCode uiCenter"><SarasTrans value="TRN" /></span>
            <span className="sRoute uiCenter"><SarasTrans value="Journey" /></span>
            <span className="sPassengerName uiCenter"><SarasTrans value="Passenger Name" /></span>
            <span className="sTktClass uiCenter"><SarasTrans value="Class" /></span>
            <span className="sCost uiCenter"><SarasTrans value="Tkt" /><br/><SarasTrans value="Cost" /></span>
            <span className="sCost uiCenter"><SarasTrans value="Selling" /><br/><SarasTrans value="Price" /></span>
        </div>
    );
}

export default InvRouteItemH
